__webpack_require__.p = "/restaurant-kam-po/";